module.exports = __webpack_public_path__ + "static/play-store-deb0f460b1034ebb8430efc771d63d52.svg";